import React from "react";
import { useEffect } from "react";
import ReactDOM from "react-dom";
import { string } from "yup/lib/locale";

export const PIDDragAndDropTableRow = (props) => {
  function copyStringWithNewLineToClipBoard(stringWithNewLines) {
    const mySmartTextarea = document.createElement("textarea");
    mySmartTextarea.innerHTML = stringWithNewLines;
    const parentElement = document.body.appendChild(mySmartTextarea);
    mySmartTextarea.select();
    document.execCommand("copy");
    // parentElement.removeChild(mySmartTextarea);
  }

  return (
    <tr key={props.rowNo}>
      <td
        style={{
          textAlign: "center",
        }}
      >
        {props.children}
      </td>
      <td
        style={
          props.screenSize === "small"
            ? { fontSize: 10, textAlign: "center" }
            : { fontSize: 13, textAlign: "center" }
        }
      >
        {props.title}
      </td>
      <td
        style={
          props.screenSize === "small"
            ? { fontSize: 10, textAlign: "center" }
            : { fontSize: 13, textAlign: "center" }
        }
        onClick={(e) => {
          const stringWithNewLines =
            (props.StaticProps1
              ? props.StaticProps1 + ":                          \n"
              : "") +
            (props.StaticProps2
              ? props.StaticProps2 + ":                          \n"
              : "") +
            (props.StaticProps3
              ? props.StaticProps3 + ":                          \n"
              : "") +
            (props.StaticProps4
              ? props.StaticProps4 + ":                          \n"
              : "") +
            (props.StaticProps5
              ? props.StaticProps5 + ":                          \n"
              : "") +
            (props.StaticProps6
              ? props.StaticProps6 + ":                          \n"
              : "") +
            (props.StaticProps7
              ? props.StaticProps7 + ":                          \n"
              : "");
          // console.log("stringWithNewLines =", stringWithNewLines);
          copyStringWithNewLineToClipBoard(stringWithNewLines);
          props.passingTextUp(stringWithNewLines);
        }}
      >
        {props.StaticProps1}
        {props.StaticProps1 ? <br /> : "No static properties"}
        {props.StaticProps2} {props.StaticProps2 ? <br /> : null}
        {props.StaticProps3} {props.StaticProps3 ? <br /> : null}
        {props.StaticProps4} {props.StaticProps4 ? <br /> : null}
        {props.StaticProps5} {props.StaticProps5 ? <br /> : null}
        {props.StaticProps6} {props.StaticProps6 ? <br /> : null}
        {props.StaticProps7}
      </td>
    </tr>
  );
};

export const PIDModalTableRow = (props) => {
  return (
    <tr>
      <td
        onClick={(e) => {
          navigator.clipboard.writeText(props.column1);
        }}
        style={{
          textAlign: "center",
        }}
      >
        {props.column1}
      </td>
      <td
        onClick={(e) => {
          navigator.clipboard.writeText(props.column2);
        }}
        style={{
          textAlign: "center",
        }}
      >
        {props.column2}
      </td>
    </tr>
  );
};

export const PIDModalTableRow2 = (props) => {
  return (
    <tr>
      <td
        onClick={(e) => {
          navigator.clipboard.writeText(props.column1);
        }}
        style={{
          textAlign: "center",
        }}
      >
        {props.column1}
      </td>
      <td
        onClick={(e) => {
          navigator.clipboard.writeText(props.column2);
        }}
        style={{
          textAlign: "center",
        }}
      >
        {props.column2}
      </td>
      <td
        onClick={(e) => {
          navigator.clipboard.writeText(props.column3);
        }}
        style={{
          textAlign: "center",
        }}
      >
        {props.column3}
      </td>
    </tr>
  );
};

export const PIDLegendTableRow = (props) => {
  return (
    <tr key={props.rowNo}>
      <td
        style={{
          textAlign: "center",
        }}
      >
        <img src={props.src} alt={props.title} height="50rem" length="50rem" />
      </td>
      <td>{props.title}</td>
      <td
        style={
          props.screenSize === "small"
            ? { fontSize: 10, textAlign: "center" }
            : { fontSize: 13, textAlign: "center" }
        }
        onClick={(e) => {
          navigator.clipboard.writeText(
            (props.StaticProps1 ? props.StaticProps1 + ": " : "") +
              (props.StaticProps2 ? props.StaticProps2 + ": " : "") +
              (props.StaticProps3 ? props.StaticProps3 + ": " : "") +
              (props.StaticProps4 ? props.StaticProps4 + ": " : "") +
              (props.StaticProps5 ? props.StaticProps5 + ": " : "") +
              (props.StaticProps6 ? props.StaticProps6 + ": " : "") +
              (props.StaticProps7 ? props.StaticProps7 + ": " : "")
          );
        }}
      >
        {props.StaticProps1}
        {props.StaticProps1 ? <br /> : "No static properties"}
        {props.StaticProps2} {props.StaticProps2 ? <br /> : null}
        {props.StaticProps3} {props.StaticProps3 ? <br /> : null}
        {props.StaticProps4} {props.StaticProps4 ? <br /> : null}
        {props.StaticProps5} {props.StaticProps5 ? <br /> : null}
        {props.StaticProps6} {props.StaticProps6 ? <br /> : null}
        {props.StaticProps7}
      </td>
    </tr>
  );
};

export const PIDCard = (props) => {
  return (
    <div className="card " key={props.headingId}>
      <div className="card-header" id={props.headingId}>
        <a
          className="collapsed"
          data-toggle="collapse"
          data-target={props.dataTarget}
          aria-expanded="false"
          aria-controls={props.ariaControls}
          href="/"
          style={
            props.screenSize === "small"
              ? { fontSize: 10, minHeight: "10px" }
              : { fontSize: 13 }
          }
        >
          {props.title}
        </a>
      </div>
      <div
        id={props.ariaControls}
        className="collapse"
        aria-labelledby={props.headingId}
        data-parent="#accordion"
      >
        <div
          className="card-body"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div>
            <table className="table table-sm table-responsive">
              <thead>
                <tr>
                  <th
                    style={
                      props.screenSize === "small"
                        ? { fontSize: 10, textAlign: "center",     inlineSize: "20px", overflowWrap: "break-word"}
                        : { fontSize: 13, textAlign: "center",      inlineSize: "20px", overflowWrap: "break-word"}
                    }
                  >
                    Symbol
                  </th>
                  <th
                    style={
                      props.screenSize === "small"
                        ? { fontSize: 10, textAlign: "center" ,      inlineSize: "20px", overflowWrap: "break-word"}
                        : { fontSize: 13, textAlign: "center" ,      inlineSize: "20px", overflowWrap: "break-word"}
                    }
                  >
                    Item
                  </th>
                  <th
                    style={
                      props.screenSize === "small"
                        ? { fontSize: 10, textAlign: "center" ,      inlineSize: "20px", overflowWrap: "break-word"}
                        : { fontSize: 13, textAlign: "center" ,      inlineSize: "20px", overflowWrap: "break-word"}
                    }
                  >
                    Static Properties
                  </th>
                </tr>
              </thead>
              <tbody>{props.children}</tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export const PIDTableHeaders = (props) => {
  return (
    <>
      <thead>
        <tr>
          <th colSpan="3" className="text-center">
            {props.title}
          </th>
        </tr>
      </thead>
      <tbody>{props.children}</tbody>
    </>
  );
};
